import React from 'react';
import PropTypes from 'prop-types';
import AuthService from 'library/authService/auth-service';
import UserProfile from 'components/userProfile/user-profile';
import { DocLink, DocPages } from 'components/Help/';
import { history } from 'store';
import { Icon } from 'antd';
import settings from 'settings';

const handleProfileClick = (e) => {
  e.preventDefault();
  history.push('/home/account/');
};

const handleLogoutClick = (e) => {
  e.preventDefault();
  AuthService.logout();
};

const getAppVersionString = () => {
  const { APP_CONFIG } = settings;
  const appVersionString = `${APP_CONFIG.environment}-${APP_CONFIG.versionNo}`;
  return appVersionString;
};

const ProfileMenu = ({ active }) => {
  const { displayName } = AuthService.whoami();
  const appVersionString = getAppVersionString();

  if (!active) {
    return null;
  }

  return (
    <div className="bhp-settings">
      <div className="bhp-settings-header">
        <UserProfile name={displayName} imageUrl={null} direction="horizontal" nameClass="bhp-title-3" />
      </div>
      <div className="bhp-settings-content">
        <a className="bhp-settings-item" onClick={handleProfileClick}>
          <Icon type="user" />
          View Profile
        </a>
        <span className="bhp-settings-item">
          <DocLink showIcon page={DocPages.contents}>Documentation</DocLink>
        </span>
        <a className="bhp-settings-item" onClick={handleLogoutClick}>
          <Icon type="logout" />
          Logout
        </a>
      </div>
      <div className="bhp-settings-version">
        Crew Rostering &copy; BHP
        <br />
        <DocLink showIcon={false} page={DocPages.changelog}>
          {appVersionString}
        </DocLink>
      </div>
    </div>
  );
};

ProfileMenu.propTypes = {
  active: PropTypes.bool
};
ProfileMenu.defaultProps = {
  active: false
};
export default ProfileMenu;
